window.aeInitProductsSliders = function () {
  if (typeof window.bindAncientAddToCartButtons === 'function') {
    window.bindAncientAddToCartButtons(document);
  }

  document.querySelectorAll('[data-ae-products-slider]').forEach((slider) => {
    if (slider.dataset.aeBound === 'true') return;
    slider.dataset.aeBound = 'true';

    const viewport = slider.querySelector('[data-ae-products-viewport]');
    const track = slider.querySelector('[data-ae-products-track]');
    const slides = Array.from(track?.children || []);
    const prev = slider.querySelector('[data-ae-products-prev]');
    const next = slider.querySelector('[data-ae-products-next]');
    const progress = slider.querySelector('[data-ae-products-progress]');
    if (!viewport || !track || !slides.length) return;

    const pageStep = () => viewport.clientWidth * 0.9;

    const updateProgress = () => {
      if (!progress) return;
      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      const ratio = maxScroll > 0 ? viewport.scrollLeft / maxScroll : 0;
      const pct = Math.max(0.12, Math.min(1, ratio || 0.12));
      progress.style.transform = `scaleX(${pct})`;
    };

    const updateArrows = () => {
      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      if (prev) prev.disabled = viewport.scrollLeft <= 1;
      if (next) next.disabled = viewport.scrollLeft >= maxScroll - 1;
    };

    const refresh = () => { updateProgress(); updateArrows(); };

    prev?.addEventListener('click', () => {
      viewport.scrollBy({ left: -pageStep(), behavior: 'smooth' });
    });
    next?.addEventListener('click', () => {
      viewport.scrollBy({ left: pageStep(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    refresh();
  });

  if (typeof window.bindAncientAddToCartButtons === 'function') {
    document.querySelectorAll('[data-ae-products-slider]').forEach((slider) => {
      window.bindAncientAddToCartButtons(slider);
    });
  }
};

(window.aeOnSectionReady || function (fn) { document.addEventListener('DOMContentLoaded', () => fn(document)); })(() => {
  window.aeInitProductsSliders();
});
